"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Types_1 = require("./Types");
var Components_1 = require("./Components");
var Components_2 = require("../../Components");
var Types_2 = require("../../Types");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var Services_1 = require("../../../../../../Services/");
var Endpoints_1 = require("../../../../../../Utils/Endpoints");
var RequestLookup = /** @class */ (function (_super) {
    __extends(RequestLookup, _super);
    function RequestLookup(props) {
        var _this = _super.call(this, props) || this;
        _this.changeRequestLookupType = function (newRequestType) {
            if (_this.state.selectedType != newRequestType) {
                _this.setState({
                    selectedType: newRequestType,
                    results: [],
                    tokens: [],
                    pending: false
                });
            }
        };
        _this.handledExpand = function (id) {
            var results = _this.state.results.map(function (result) {
                var _a;
                if (result.id == id) {
                    result.serialNumber = React.createElement("span", { style: { cursor: "pointer" }, onClick: function () { _this.handledExpand(id); } },
                        React.createElement(react_fontawesome_1.FontAwesomeIcon, { className: "mr-2", icon: _this.state.expanded.includes(id) ? free_solid_svg_icons_1.faPlusCircle : free_solid_svg_icons_1.faMinusCircle }),
                        result.action,
                        " (", (_a = result.packs) === null || _a === void 0 ? void 0 :
                        _a.length,
                        ")");
                }
                return result;
            });
            _this.setState({
                expanded: _this.state.expanded.includes(id) ? _this.state.expanded.filter(function (x) { return x !== id; }) : __spreadArrays(_this.state.expanded, [id]),
                results: results
            });
        };
        _this.fetchResults = function () {
            var body = JSON.stringify(_this.state.request);
            Services_1.postJson(Endpoints_1.default.GetRequestLookup, body, undefined, true, new Services_1.UserRequestHeaders(__assign(__assign({}, Services_1.Auth.getUser()), { Location: _this.props.applicationData.selectedLocation }))).then(function (results) {
                var j = JSON.parse(results);
                var reportRows = Services_1.ReportsRequestService.parseServerData(j.records);
                var data = [];
                var nonExpandable = [];
                reportRows.map(function (row) {
                    nonExpandable.push(row.id);
                    data.push(Types_2.ReportGenerator.getReport(row, row.id, _this.props.applicationData.resources, function () { _this.handledExpand(row.id); }));
                });
                var tokens = _this.state.tokens;
                if (j.token) {
                    tokens.push(j.token);
                }
                _this.setState(function (prevState) { return ({
                    results: data,
                    pending: false,
                    tokens: tokens,
                    nonExpandable: nonExpandable
                }); });
            })
                .catch(function (err) { return console.error(err); });
        };
        _this.filterUpdate = function (filters) {
            //this.requestTimer = Date.now();
            _this.setState(function (prevState) { return ({
                results: [],
                tokens: [],
                request: __assign(__assign({}, prevState.request), { productCode: filters.productCode, serialNumber: filters.serialNumber, transactionId: filters.transactionId, uprc: filters.uprc, token: null, page: 1 }),
                pending: true
            }); }, _this.fetchResults);
        };
        _this.tableUpdate = function (page, itemCount) {
            _this.setState({ pending: true, results: [] });
            var tokens = _this.state.tokens;
            if (_this.state.request.page > page) {
                tokens.pop();
                if (tokens.length == page) {
                    tokens.pop();
                }
            }
            var token = tokens.length > 0 ? tokens[tokens.length - 1] : null;
            _this.setState(function (prevState) { return ({
                request: __assign(__assign({}, prevState.request), { page: page, itemCount: itemCount, token: token }),
                pending: true,
                tokens: tokens
            }); }, _this.fetchResults);
        };
        _this.getTablePage = function () {
            var totalSize = (_this.state.request.page * 10) + (_this.state.request.page <= _this.state.tokens.length ? 1 : 0);
            return totalSize;
        };
        _this.getExpandedRow = function () {
            return {
                renderer: function (row) {
                    var _a;
                    var packs = (_a = row.packs) === null || _a === void 0 ? void 0 : _a.map(function (pack) {
                        return (React.createElement("tr", { key: pack.serialNumber },
                            React.createElement("td", { style: { width: "30%" } }, pack.serialNumber),
                            React.createElement("td", { style: { width: "30%" } }, pack.submissionTime),
                            React.createElement("td", { style: { width: "15%" } }, pack.action),
                            React.createElement("td", { style: { width: "15%" } }, pack.RAG),
                            React.createElement("td", { style: { width: "10%" } }, pack.UPRC)));
                    });
                    return (React.createElement("table", { style: { width: "100%" } },
                        React.createElement("tbody", null, packs)));
                },
                expanded: _this.state.expanded,
                nonExpandable: _this.state.nonExpandable
            };
        };
        _this.state = {
            selectedType: Types_1.RequestLookupType.None,
            nonExpandable: [],
            expanded: [],
            request: {
                token: null,
                page: 1,
                itemsCount: 10
            },
            pending: false,
            tokens: [],
            results: []
        };
        return _this;
    }
    RequestLookup.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(Components_1.RequestLookupFilters, { selectedType: this.state.selectedType, changeRequestLookupType: this.changeRequestLookupType, fetchResults: this.filterUpdate, resources: this.props.applicationData.resources }),
            this.state.selectedType !== Types_1.RequestLookupType.None && React.createElement(Components_2.ReportsTable, { tableChangeHandler: this.tableUpdate, page: this.state.request.page, totalSize: this.getTablePage(), data: this.state.results, pending: this.state.pending, expandRow: this.getExpandedRow(), resources: this.props.applicationData.resources })));
    };
    return RequestLookup;
}(React.Component));
exports.RequestLookup = RequestLookup;
//# sourceMappingURL=RequestLookup.js.map